var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { Marker } from '@react-google-maps/api';

var MarkerPois = function (_Component) {
    _inherits(MarkerPois, _Component);

    function MarkerPois(props) {
        _classCallCheck(this, MarkerPois);

        var _this = _possibleConstructorReturn(this, (MarkerPois.__proto__ || Object.getPrototypeOf(MarkerPois)).call(this, props));

        _this.showMarkerContent = function () {
            _this.setState({
                isShown: !_this.state.isShown
            });
        };

        _this.getPixelPositionOffset = function (width, height) {
            return {
                x: -(width / 2),
                y: -(height / 2)

            };
        };

        _this.onClick = function () {
            _this.setState({
                popUpInfo: !_this.state.popUpInfo
            });
            // document.getElementById("vehicle").style.display = "block";
            // console.log("hola")
        };

        _this.state = {
            position: {
                lat: _this.props.position.lat,
                lng: _this.props.position.lng
            },
            clusterer: _this.props.clusterer,
            isShown: true,
            class1: '',
            backgroundColor: '',
            popUpInfo: false
        };

        return _this;
    }

    _createClass(MarkerPois, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'div',
                null,
                React.createElement(Marker, {
                    position: this.state.position,
                    clusterer: this.state.clusterer
                    // onVisibleChanged={this.showMarkerContent}
                    // icon={{ path: '' }}
                    // icon={{path: 'google.maps.SymbolPath.CIRCLE', scale: 0}}
                    , icon: "https://logos.4gflota.com/Iconos_Web/iconosTipoPOI/imagen" + this.props.icon + ".png",
                    onClick: this.props.showCircle.bind(this, this.props.content)
                })
            );
        }
    }]);

    return MarkerPois;
}(Component);

export default MarkerPois;